import { render, staticRenderFns } from "./branchcards.vue?vue&type=template&id=7da641a7&scoped=true&"
import script from "./branchcards.vue?vue&type=script&lang=js&"
export * from "./branchcards.vue?vue&type=script&lang=js&"
import style0 from "./branchcards.vue?vue&type=style&index=0&id=7da641a7&lang=scss&scoped=true&"
import style1 from "./branchcards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da641a7",
  null
  
)

export default component.exports